import { IsString, ValidateNested } from 'class-validator';
import { PageResponseVm } from 'api/core/page-response.vm';
import { OrderItemVm } from './order-item.vm';
import { Type } from 'class-transformer';

export class GetOrderItemsVm extends PageResponseVm<OrderItemVm, string> {
  @IsString()
  nextOffset: string;

  @Type(() => OrderItemVm)
  @ValidateNested({ each: true })
  objects: OrderItemVm[];
}
